export default {
  moduleHMLVersion: (state) => (moduleId) => state.modulesHMLVersion[moduleId],
};
